import * as React from "react";
import type { SVGProps } from "react";

const SvgLinkedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.286 6v12H0V6zm5.617 0v2.294C10.38 7.654 11.823 6 14.098 6c.266 0 .493.03.7.07l.158.031c.044.012.083.027.125.04A3.89 3.89 0 0 1 18 9.902V18h-3.902v-7.636c-1.173-2.844-3.86.64-4.166 1.052l-.025.034-.004.005V18H6V6zM1.714 0a1.715 1.715 0 1 1 .002 3.428A1.715 1.715 0 0 1 1.714 0"
    />
  </svg>
);
export default SvgLinkedIn;
